export const createCollectHTML = (text) => {
  const container = document.createElement('div');
  container.id = 'backpack-popup';
  container.className = 'backpack-popup-wrapper';
  container.style.height = `100px`;

  const content = document.createElement('div');
  content.className = 'backpack-popup-content';

  const itemRefArr = [];
  const menuItem = document.createElement('div');
  menuItem.className = 'backpack-popup-item';
  menuItem.innerHTML = text;
  itemRefArr.push(menuItem);
  content.appendChild(menuItem);

  container.appendChild(content);
  document.body.appendChild(container);
  return container;
};
